import { render, staticRenderFns } from "./search-account.vue?vue&type=template&id=50a7c721&scoped=true"
import script from "./search-account.vue?vue&type=script&lang=js"
export * from "./search-account.vue?vue&type=script&lang=js"
import style0 from "./search-account.vue?vue&type=style&index=0&id=50a7c721&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7c721",
  null
  
)

export default component.exports